/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import MainLayout from 'components/layouts/main'
import { ArticleList } from 'features';
import { notifySuccess, notifyError } from 'components/commons/toast'

import { NewsArticlesSelector, NewsArticlesTypes } from 'store';
import { getNewsArticlesData, setArticleVisibility } from 'services';

import { ToastContainer } from 'react-toastify'
import { responseMessage } from 'constant'

const NewsArticlesPage = () => {

  const {
    articles = [],
    limit,
    isRequesting,
    hasDataToLoad,
    orderRef,
    order,
  } = useSelector(NewsArticlesSelector)

  const dispatch = useDispatch();

  useEffect(() => {
    getNews({
      articles,
      displayLoader: true
    })
  }, [])

  const getNews = ({ articles, displayLoader = true }: any) => {
    if (isRequesting || !hasDataToLoad) {
      return false
    }

    dispatch({
      type: NewsArticlesTypes.GET_NEWS_ARTICLES_DATA,
      payload: { loading: displayLoader },
    })

    setTimeout(async () => {
      await getNewsArticlesData({ articles, limit, order, orderRef }).then((payload) => {
        dispatch({
          type: NewsArticlesTypes.SET_NEWS_ARTICLES_DATA,
          payload,
        })
      })
    }, 1250)
  }

  const loadMoreData = () => {
    getNews({
      articles,
      displayLoader: true
    })
  }

  const onSetActive = async (data: any) => {
    await setArticleVisibility(data).then((payload: any) => {
      const message = data.active || data.active == null
        ? responseMessage.successHide
        : responseMessage.successUnhide

      notifySuccess(message)

      dispatch({
        type: NewsArticlesTypes.UPDATE_NEWS_ARTICLE_DATA,
        payload,
      })
    })
      .catch((error) => {
        console.log(error)
        const message = data.active || data.active == null
          ? responseMessage.errorHide
          : responseMessage.errorUnhide
        notifyError(message)
      })
  }

  return (
    <React.Fragment>
      <MainLayout>
        <h1 className='font-bold text-4xl text-center py-10 md:text-left lg:text-left md:px-6 lg:px-6'>
          News Articles
        </h1>

        <ToastContainer limit={1} autoClose={3000} />

        <ArticleList
          {...{
            articles,
            isRequesting,
            hasDataToLoad,
            onSetActive
          }}
          onLoadMore={loadMoreData}
        />
      </MainLayout>
    </React.Fragment>
  );
};

export default NewsArticlesPage;